export default [
  { name: "metal_ceramic", boolean: "metalCeramicCrown" },
  { name: "metal_free_crown", boolean: "metalFreeCrown" },
  { name: "metallic_crown", boolean: "metallicCrown" },
  { name: "temporary_crown", boolean: "temporalCrown" },
];
